export class GetInfomationCustomerModel {
    FilterText: string;
    IsCorp: boolean;
}

export class GetQueueBookingModel {
    Code: string;
    SearchByIdentity: boolean;
}

export class GetQueueBookingForTabletModel {
    Code: string;
    SearchByIdentity: boolean;
    CompanyCode: string;
}

export class GetInfoQueueModel {
    PhoneNumber: string;
    CustomerCode: string;
    FullName: string;
    OrgCode: string
    ProductGroupId: number;
    VisitorId: string;
    IsZalo: boolean;
    IsRequestFromCVTV: boolean;
}

export class GetBranchCodeModel {
    DataQr: string;
    VisitorId: string;
    MobilePhone: string;
    OrgCode: string;
    IsSCP: boolean;
    UrlQR: string;
    IsRequestFromCVTV: boolean;
}

export class CheckExistQueueInput {
    NationalId: string;
    CustomerCode: string;
    FullName: string;
    OrgCode: string;
}